import { render, staticRenderFns } from "./ContactGroupClass.vue?vue&type=template&id=033014df&scoped=true&"
import script from "./ContactGroupClass.vue?vue&type=script&lang=js&"
export * from "./ContactGroupClass.vue?vue&type=script&lang=js&"
import style0 from "./ContactGroupClass.vue?vue&type=style&index=0&id=033014df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033014df",
  null
  
)

export default component.exports